import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchActivities', request, cancelToken)
}

export {get}
